export default __webpack_public_path__ + "static/media/best-jobs-2021-badge-graphic.575f44dd.svg";